import { Award } from 'lucide-react'
import Card from '../../components/Card'
import StatStrip from '../../components/StatStrip'
import { strings as S } from './strings'
import './userDetails.css'

/**
 * T11 — النقاط والمستويات: the user's totals, then the badge ladder.
 *
 * The legacy renders the badge grid from `GetUserPoints` and fades the container out
 * when the user holds none. dbo.PointsBadges carries the ten badges and their point
 * thresholds but awards nobody, so the standing is read off the ladder in `getUser`:
 * earned badges are solid, the rest stay quiet with the threshold that unlocks them.
 */
export default function PointsTab({ user }) {
  const badges = user.badges ?? []
  const earned = badges.filter((badge) => badge.earned).length

  return (
    <>
      <Card title={S.tabs.points}>
        <p className="ud__points-description">
          {S.points.description.split('\n').map((line) => (
            <span key={line}>
              <bdi>{line}</bdi>
            </span>
          ))}
        </p>

        <StatStrip
          items={[
            {
              id: 'positive',
              icon: Award,
              label: S.points.positive,
              value: user.pointsPositive ?? 0,
              tone: 'success',
            },
            {
              id: 'negative',
              label: S.points.negative,
              value: user.pointsNegative ?? 0,
              tone: 'danger',
            },
            {
              id: 'risk',
              label: S.points.riskLevel,
              value: user.pointsRiskLevelName ?? '-',
              tone: 'warning',
            },
          ]}
        />
      </Card>

      {badges.length > 0 && (
        <Card title={`${S.points.badges} (${earned}/${badges.length})`}>
          <ul className="ud__badges">
            {badges.map((badge) => (
              <li
                key={badge.id}
                className={`ud__badge${badge.earned ? ' is-earned' : ''}`}
                title={badge.description || undefined}
              >
                <span className="ud__badge-icon">
                  <Award size={19} strokeWidth={1.75} />
                </span>
                <span className="ud__badge-name">
                  <bdi>{badge.name}</bdi>
                </span>
                <span className="ud__badge-points">{badge.points}</span>
              </li>
            ))}
          </ul>
        </Card>
      )}
    </>
  )
}
